var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-input-number" }, [
    _c(
      "button",
      {
        class: ["button", { disabled: +_vm.value <= +_vm.min }],
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.decreaseNumber.apply(null, arguments)
          }
        }
      },
      [_c("span", { staticClass: "text" }, [_vm._v("-")])]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "input",
      attrs: {
        type: "number",
        autocomplete: "new-password",
        min: _vm.min,
        max: _vm.max,
        debounce: "500"
      },
      domProps: { value: _vm.numericValue },
      on: { keypress: _vm.validateInput }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        class: ["button", { disabled: +_vm.max <= +_vm.value }],
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.increaseNumber.apply(null, arguments)
          }
        }
      },
      [_c("span", { staticClass: "text" }, [_vm._v("+")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27221716", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27221716","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CInputNumber.vue
// module id = 2235
// module chunks = 1610